module.exports = __webpack_public_path__ + "img/kwai.7b591f64.svg";